import { AxiosResponse } from "axios";
import { AuthMeResponse, LoginResponse, LogoutResponse } from "./auth.types";
import { api, apiLogin } from "../api";

// Uses `apiLogin` (no interceptors) for the same reason /auth/login did: a
// rejected sign-in must surface its own 401/403 to the caller instead of
// being swallowed by the refresh-and-retry interceptor.
export const loginWithGoogle = async (idToken: string) => {
  const response: AxiosResponse<LoginResponse> = await apiLogin.post(
    "/auth/google",
    { idToken }
  );

  return response.data;
};

// Uses the interceptor-covered `api` instance (not `apiLogin`): the Bearer
// token is attached per-request and a 401 here gets the single-flight
// refresh-and-retry, same as any other authenticated call.
export const getAuthMe = async (): Promise<AuthMeResponse> => {
  const response: AxiosResponse<AuthMeResponse> = await api.get("/auth/me");
  return response.data;
};

export const logout = async (refreshToken: string): Promise<LogoutResponse> => {
  const response: AxiosResponse<LogoutResponse> = await api.post(
    "/auth/logout",
    { refreshToken }
  );
  return response.data;
};
